export default __webpack_public_path__ + "static/media/control-3-white.d418c8e4.svg";